import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

interface Props {
  label?: string;
}

const ProductViewerSkeleton: React.FC<Props> = ({
  label = '',
}) => {
  return (
    <Box
      position="relative"
      width="100%"
      height="100%"
      display="inline-block"
      mr="1rem"
    >
      <Skeleton variant="rectangular" width="100%" height="100%" />

      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <Typography variant="subtitle1" fontWeight="bold" color="textPrimary">
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default ProductViewerSkeleton;